const styles = theme => ({
  pModal: {
    marginTop: "15px",
    fontSize: "15px",
    fontFamily: "Open Sans",
  },
  pModal2: {
    marginTop: "15px",
    fontSize: "15px",
    fontFamily: "Open Sans",
    color: "red",
  },
  pModalHeader: {
    fontFamily: "Open Sans",
  },
  pModalTitle: {
    textAlign: "left",
    fontSize: "15px",
    color: "red",
    fontWeight: "bold",
    marginBottom: "15px",
    textTransform: "uppercase",
    fontFamily: "Open Sans",
  },
  pModalSubtitle: {
    textAlign: "left",
    fontSize: "11px",
    color: "red",
    marginBottom: "15px",
    textTransform: "uppercase",
    fontFamily: "Open Sans",
  },
  spinnerWrapper: {
    padding: theme.spacing(1),
    display: "flex",
    justifyContent: "center",
  },
  textMod: {
    display: "flex",
    justifyContent: "space-between",
  },
  textMod2: {
    color: theme.palette.primary.main,
  },
})

export default styles
